export default function draw() {
  this.ctx.beginPath();
  this.ctx.arc(this.anim.x, this.anim.y, this.anim.r, 0, Math.PI * 2);
  this.ctx.fillStyle = "#353752";
  this.ctx.fill();
  this.ctx.strokeStyle = `rgba(255, 255, 0, ${this.opacity})`;
  // this.opacity -= 0.1;
  this.ctx.lineWidth = 2;
  this.ctx.stroke();
  // this.anim.r += 0.1;
}
